import React from 'react'

function TenderTextDS() {
    return (
        <embed src="\pdfs\EAT1.6.4.1_DS_Step_twist_outlet_kr.pdf" width="100%" height="2100px" />
    )
}

export default TenderTextDS